import request from "@/common/request";
import { Page } from "@/models";
import { MotivoCancelamento } from "@/models/MotivoCancelamento";

export const createMotivo = async (motivo: MotivoCancelamento): Promise<MotivoCancelamento> =>
	request.post(`/motivosCancelamento`, motivo)

export const updateMotivo = async (motivo: MotivoCancelamento): Promise<MotivoCancelamento> =>
	request.put(`/motivosCancelamento/${motivo.id}`, motivo)

export const findMotivo = async (params?: any): Promise<Page<MotivoCancelamento>> =>
	request.get(`/motivosCancelamento`, {
		params: {
			...params,
		},
	})

export const findById = async (id: string): Promise<MotivoCancelamento> =>
	request.get(`/motivosCancelamento/find/${id}`)	